import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import "./Header.css";

const Header = (props) => {
    return (
        <div className="header">
            <Link to="/" className="logo-link"><div className="logo">Daniele<b>Argiolas</b></div></Link>
        </div>
    );
}

export default Header;